exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{font-family:\"Helvetica Neue\", Helvetica, Arial, sans-serif}.round{border-radius:50%}\n", ""]);

// exports
